import { z } from 'zod';
import {
  dashboardAndAllocationFilterFormDefaultValues,
  dashboardAndAllocationFilterFormSchema,
  markIdFilterDefaultValue,
  markIdFilterSchema,
  markerFilterDefaultValue,
  markerFilterSchema,
  nsnFilterDefaultValue,
  nsnFilterSchema,
  responseIdFilterDefaultValue,
  responseIdFilterSchema
} from 'pages/marking/schemas/shared-filter-form.schema';
import { yesNoOrBothSchema } from 'schemas/yes-no-or-both.schema';
import type { MarkStatus } from 'services/assist-api/entities/test-instance-response-mark/types';

export const filterFormSchema = z.intersection(
  z.intersection(
    z.intersection(
      z.intersection(dashboardAndAllocationFilterFormSchema, nsnFilterSchema),
      z.intersection(responseIdFilterSchema, markIdFilterSchema)
    ),
    markerFilterSchema
  ),
  z.object({
    statuses: z.array(z.custom<MarkStatus>()),
    review: yesNoOrBothSchema,
    comment: yesNoOrBothSchema,
    markingStarted: yesNoOrBothSchema,
    allocatedToMeOnly: z.boolean()
  })
);

export type FilterFormValues = z.infer<typeof filterFormSchema>;

export const filterFormDefaultValues: FilterFormValues = {
  ...dashboardAndAllocationFilterFormDefaultValues,
  ...nsnFilterDefaultValue,
  ...responseIdFilterDefaultValue,
  ...markIdFilterDefaultValue,
  ...markerFilterDefaultValue,
  statuses: [],
  review: '',
  comment: '',
  markingStarted: '',
  allocatedToMeOnly: false
};
